import { FC, KeyboardEvent, memo, MouseEvent } from 'react';
import { Box } from '@chakra-ui/react';

import { EventCaptureProps } from './types/EventCaptureProps';

const handleClick = (e: MouseEvent<HTMLDivElement>) => {
  e.stopPropagation();
};

const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
  e.stopPropagation();
};

const EventCaptureComponent: FC<EventCaptureProps> = ({
  children,
  captureOnClick = false,
  captureOnKeyDown = false,
  ...props
}) => {
  const eventHandlers = {
    ...(captureOnClick && { onClick: handleClick }),
    ...(captureOnKeyDown && { onKeyDown: handleKeyDown }),
  };

  return (
    <Box {...props} {...eventHandlers}>
      {children}
    </Box>
  );
};

export const EventCapture = memo(EventCaptureComponent);
